import { render, staticRenderFns } from "./FortuneWheel.vue?vue&type=template&id=3621bbc2&"
import script from "./FortuneWheel.vue?vue&type=script&lang=js&"
export * from "./FortuneWheel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports